export default "__VITE_ASSET__D4FZI3lv__"